import { symbol } from "prop-types";
import styled from "styled-components";
import { deviceType } from "@tm/static/utils";

export const PageContainer = styled.div`
  background: #f2f2f2;
  padding: 30px;
  /* height: calc(100vh- 80px); */
  @media ${deviceType.mobile} {
    padding: 60px 0 30px;
    /* margin-top:-8px; */
  }
`;

export const PageGreyWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  background: #f2f2f2;
  /* height: calc(100vh - 80px); */
  gap: 16px;
  display: flex;
  flex-direction: column;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;
